import axios from 'axios';
import React, { useMemo } from 'react';

import { AppContext } from '../App';
import Products from './Products';
import './index.scss';
import { InternalOptions } from '../types';

interface AISProps {}

const AIS: React.FC<AISProps> = () => {
  const {
    dispatch,
    countryCode,
    page,
    successfulExtraction,
    forceDesktop,
    productExperience,
    userFullName,
    accountProducts,
    customizationName,
    pfcVersion,
  } = React.useContext(AppContext);
  const [error, setError] = React.useState('');
  const internalOptions: InternalOptions = useMemo(() => ({}), []);
  if (forceDesktop) {
    internalOptions.forceDesktop = true;
  }

  React.useEffect(() => {
    axios
      .post(
        `${process.env.REACT_APP_SERVER_URL}/token/create_link_token`,
        {
          countryCode,
          isIdentityMatch: productExperience === 'identitymatch',
          accountProducts,
          language: 'en',
          customizationName,
          pfcVersion,
        },
        { withCredentials: true },
      )
      .then((response) => {
        if (response.data.item_created) {
          dispatch({
            type: 'SET_SUCCESSFUL_EXTRACTION',
            payload: {
              successfulExtraction: true,
            },
          });
        }
        if (response.data.link_token) {
          // @ts-ignore
          let plaidLink = Plaid.create(
            {
              token: response.data.link_token,
              // @ts-ignore
              onSuccess: async (public_token, metadata) => {
                axios
                  .post(
                    `${process.env.REACT_APP_SERVER_URL}/token/get_access_token`,
                    { publicToken: public_token },
                    { withCredentials: true },
                  )
                  .then((accessTokenResponse) => {
                    if (accessTokenResponse.data.error != null) {
                      setError(error);
                    }
                    dispatch({
                      type: 'SET_SUCCESSFUL_EXTRACTION',
                      payload: {
                        successfulExtraction: true,
                      },
                    });
                  });
              },
              // @ts-ignore
              onExit: async (err, metadata) => {
                plaidLink = undefined;
                // Return to the Landing page for any error or exit event from Link.
                dispatch({
                  type: 'SET_PAGE',
                  payload: {
                    page: 'landing',
                  },
                });
              },
              // @ts-ignore
              onEvent: () => {},
            },
            internalOptions,
          );
          plaidLink.open();
          // Change Link's zIndex so the demo banner can be seen
          const iframes = Array.from(document.getElementsByTagName('iframe'));
          iframes.forEach((iframe) => (iframe.style.zIndex = '2147483646'));
        } else {
          setError(response.data.error);
        }
      })
      .catch((error) => {
        setError(error);
      });
  }, [
    dispatch,
    page,
    setError,
    countryCode,
    error,
    productExperience,
    accountProducts,
    internalOptions,
    customizationName,
    pfcVersion,
  ]);

  return (
    <div className="Account">
      <div className="Account__title">
        {successfulExtraction && (
          <Products
            userFullName={userFullName}
            productExperience={productExperience}
          />
        )}
        {error && 'Error while processing. Please try again'}
      </div>
    </div>
  );
};

export default AIS;
